const { getPoleOfInaccessibility } = require('../mapUtils');

/**
 * Creates an SVG overlay with text that dynamically fits inside the polygon bounds.
 * Shrinks font size as needed to ensure the label remains inside.
 */
const createFittedTextMarker = async function(layer, locationRecord) {
  // Attempt to find an interior point (pole of inaccessibility)
  let layerCenter;
  try {
    const pole = await getPoleOfInaccessibility(layer, 0.00001);
    if (Array.isArray(pole)) {
      layerCenter = { lat: pole[1], lng: pole[0] };
    }
  } catch (_) {
    // fallback
  }
  if (!layerCenter) {
    layerCenter = layer.getBounds().getCenter();
  }

  // Compute polygon bounds
  const bounds = layer.getBounds();
  const sw = bounds.getSouthWest();
  const ne = bounds.getNorthEast();
  const widthDeg = ne.lng - sw.lng;
  const heightDeg = ne.lat - sw.lat;

  // Set up viewBox matching aspect ratio
  const viewBoxHeight = 100;
  const viewBoxWidth = heightDeg > 0
    ? (widthDeg * viewBoxHeight) / heightDeg
    : viewBoxHeight;
  const vbW = viewBoxWidth || viewBoxHeight;
  const vbH = viewBoxHeight;

  // Prepare lines of text
  const lines = locationRecord.roomNumber
    ? [String(locationRecord.roomNumber), String(locationRecord.name)]
    : [String(locationRecord.name)];

  // Compute font sizes to fit
  const fonts = [];
  if (lines.length === 1) {
    const text = lines[0];
    const maxSize = vbH * 0.8;
    const byWidth = (vbW * 0.9) / (text.length * 0.6);
    const cappedSize = Math.min(maxSize, byWidth, 18); // max font size cap
    fonts.push(cappedSize);
  } else {
    const maxLine = (vbH * 0.9) / lines.length;
    lines.forEach(text => {
      const byWidth = (vbW * 0.9) / (text.length * 0.6);
      const cappedSize = Math.min(maxLine, byWidth, 18); // max font size cap
      fonts.push(cappedSize);
    });
  }

  // Build SVG element
  const svgEl = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
  svgEl.setAttribute('xmlns', 'http://www.w3.org/2000/svg');
  svgEl.setAttribute('viewBox', `0 0 ${vbW} ${vbH}`);

  // Transparent background
  const bg = document.createElementNS(svgEl.namespaceURI, 'rect');
  bg.setAttribute('width', vbW);
  bg.setAttribute('height', vbH);
  bg.setAttribute('fill', 'none');
  svgEl.appendChild(bg);

  // Add text lines
  lines.forEach((txt, i) => {
    const fontSize = fonts[i];
    const y = (i + 1) * (vbH / (lines.length + 1));
    const t = document.createElementNS(svgEl.namespaceURI, 'text');
    t.setAttribute('x', vbW / 2);
    t.setAttribute('y', y);
    t.setAttribute('text-anchor', 'middle');
    t.setAttribute('dominant-baseline', 'middle');
    t.setAttribute('style', `font-size:${fontSize}px;fill:#000;pointer-events:none`);
    t.textContent = txt;
    svgEl.appendChild(t);
  });

  // Create SVG overlay for those bounds
  const overlayBounds = [
    [sw.lat, sw.lng],
    [ne.lat, ne.lng]
  ];
  return L.svgOverlay(svgEl, overlayBounds, { interactive: false, bubblingMouseEvents: true });
};

module.exports = createFittedTextMarker;